export function reportCoverageNotes(
  coverage: Record<string, unknown>,
): string[] {
  const notes: string[] = []
  if (coverage.complete === false) {
    notes.push(
      "The data snapshot is incomplete. Only fully covered weeks support comparisons; older history may be unavailable.",
    )
  }
  const supplied = coverage.limitations
  if (Array.isArray(supplied)) {
    notes.push(
      ...supplied.filter((note): note is string => typeof note === "string"),
    )
  }
  const quality = coverage.quality_sample
  if (
    quality &&
    typeof quality === "object" &&
    "scope" in quality &&
    quality.scope === "selected_runs_only"
  ) {
    const sample = quality as Record<string, unknown>
    notes.push(
      `Custom judge results cover ${typeof sample.run_count === "number" ? sample.run_count : "selected"} runs${typeof sample.observations_with_string_metrics === "number" ? ` (${sample.observations_with_string_metrics.toLocaleString()} conversations)` : ""}; this sample does not represent every conversation.`,
    )
  }
  return notes
}
